import { connect } from 'react-redux';
import DailySeancesSingleCinemaComponent from 'app/components/Seances/DailySeancesSingleCinemaComponent';
import { getPreparedDailySeances } from 'app/selectors/DailySeancesSelectors';
import { IReduxState } from 'app/types/state';
import { getCurrencySymbol, getCurrentCityId, getIsMonitor } from 'app/selectors/AppSelectors';
import { getSeanceDisplaySettings } from 'app/selectors/AfishaSelectors';
import { IPreparedDailySeance } from 'app/types/common';

interface IOwnProps {
	seances?: IPreparedDailySeance[];
}

const mapStateToProps = (state: IReduxState, { seances }: IOwnProps) => ({
	preparedDailySeances: seances ?? getPreparedDailySeances(state),
	seanceDisplaySettings: getSeanceDisplaySettings(state),
	currencySymbol: getCurrencySymbol(state),
	cityId: getCurrentCityId(state),
	isMonitor: getIsMonitor(state),
});

export type DailySeancesSingleCinemaProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(DailySeancesSingleCinemaComponent);
